import styled from 'styled-components';

export const StyledButton = styled.button`
    width: 100px;
    border-radius: 10px;
    border: none;
    padding: 5px 2px;
    color: #6E4884;
    transition: background-color 0.2s;
    font-family: 'Poppins';

    &:focus {
        outline: none;
    }
    &:hover {
        background-color: white;
        color: black;
    }
`;

export const GoogleLoginButton = styled.button`
  height: 50px;
  width: 300px;
  font-size: 20px;
  background-color: #D5B3E7;
  border-radius: 10px;
  border: none;
  font-family: "Poppins";
  display: flex;
  justify-content: center;
  align-items: center;

  &:focus {
    outline: none;
  }

  &:hover {
    cursor: pointer;
  }
`;